import React from 'react';
import { Helmet } from 'react-helmet';
import { useSiteMetadata } from '../utilities/use-site-metadata';

export type Props = {
  title?: string;
  description?: string;
};

const MetaTags = ({ title, description }: Props) => {
  const {
    siteName,
    siteUrl,
    description: siteDefaultDescription,
    metaImage,
  } = useSiteMetadata();
  const pageTitle = title ? `${title} - ${siteName}` : siteName;
  const pageDescription = description
    ? `${description}`
    : siteDefaultDescription;
  const {
    childImageSharp: { fixed: { src: metaImageRelativePath = '' } = {} } = {},
  } = metaImage || {};
  const metaImageURL = metaImageRelativePath
    ? siteUrl + metaImageRelativePath
    : '';

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <html lang="en" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:image" content={metaImageURL} />
      <meta property="og:description" content={pageDescription} />
      <meta property="description" content={pageDescription} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta
        name="google-site-verification"
        content="FU9ZkoqotLLvSayuWsZITiRvaGcc53ZZM-GVy43LMY0"
      />
    </Helmet>
  );
};

export default MetaTags;
